import GLightbox from "glightbox";
import InlineFormset from "./InlineFormset";

document.addEventListener("DOMContentLoaded", function (event) {

    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    let sibblingtoggles = document.querySelectorAll('[data-behaviour="toggle-sibbling"]');

    sibblingtoggles.forEach(element => {
        element.addEventListener('click', () => {
            let secondaryInfo = element.parentNode.parentNode.nextElementSibling;
            let firstChild = secondaryInfo.firstElementChild;
            let neededHeight = firstChild.offsetHeight;
            secondaryInfo.classList.toggle('managepage--show');
            element.parentNode.parentNode.classList.toggle('managepage--show');
            element.classList.toggle('managepage--show');
            if(secondaryInfo.classList.contains('managepage--show')){
                secondaryInfo.style.height = neededHeight + 'px';
                element.innerHTML = 'WENIGER';
            } else {
                secondaryInfo.style.height = '0px';
                element.innerHTML = 'MEHR';
            }
        })
    });

    let helptext_toggle = document.querySelectorAll('[data-behaviour="toggle-helptext"]');

    helptext_toggle.forEach(element => {
        element.addEventListener('click', () => {
            element.parentElement.classList.toggle('helptext--show');
        })
    });

    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    const inlineFormsets = document.querySelectorAll('[data-behaviour="inline-formset"]');

    inlineFormsets.forEach(formset => {
        new InlineFormset(formset);
        // const template = formset.querySelector('[class="inline-formset-template"]');
        // const formList = formset.querySelector('[class="inline-formset-forms"]');
        //
        // const addButton = document.createElement('button');
        // addButton.classList.add('button');
        // addButton.innerHTML = '+';
        // addButton.addEventListener('click', e => {
        //     e.preventDefault();
        //     formList.appendChild(template.content.cloneNode(true));
        // });
        // formset.insertAdjacentElement('beforeend', addButton);
    });
});
